var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEatingOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Restaurant-Seat--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Restaurant Seat Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.34 2.48a2.48 2.48 0 1 0 4.96 0 2.48 2.48 0 1 0 -4.96 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.27 11.92a1.49 1.49 0 0 0 0 -3h-0.77a4.41 4.41 0 0 1 -2.37 -0.68L5.61 6.68a1.5 1.5 0 0 0 -0.79 -0.22A1.49 1.49 0 0 0 3.33 8v6a2.48 2.48 0 0 0 2.48 2.48h2.35a0.26 0.26 0 0 1 0.19 0.09 0.23 0.23 0 0 1 0.05 0.21l-0.57 2.89A1.48 1.48 0 0 0 9 21.33a1.36 1.36 0 0 0 0.29 0 1.49 1.49 0 0 0 1.46 -1.2l0.75 -3.78a2.48 2.48 0 0 0 -2.43 -3H6.56a0.25 0.25 0 0 1 -0.25 -0.25v-2.18a0.14 0.14 0 0 1 0.08 -0.13 0.15 0.15 0 0 1 0.16 0 7.46 7.46 0 0 0 4 1.13Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23 9.1h-2.49a0.48 0.48 0 0 0 -0.37 0.17 0.51 0.51 0 0 0 -0.12 0.39l0.5 3.48a0.49 0.49 0 0 0 0.49 0.43h1.49a0.49 0.49 0 0 0 0.49 -0.43l0.5 -3.48a0.47 0.47 0 0 0 -0.12 -0.39 0.48 0.48 0 0 0 -0.37 -0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 5.12h-0.49a0.51 0.51 0 0 0 -0.49 0.38l-1 3.83 0 0.24v3.5a0.49 0.49 0 0 0 0.49 0.5h2.49a0.49 0.49 0 0 0 0.49 -0.5v-3.5l0 -0.24 -1 -3.83a0.49 0.49 0 0 0 -0.49 -0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84 22a1 1 0 1 0 0 2h3.47a1 1 0 1 0 0 -2h-0.49a0.25 0.25 0 0 1 -0.25 -0.25v-2a0.25 0.25 0 0 1 0.25 -0.25h0.25a1 1 0 0 0 0 -2H2.33a0.25 0.25 0 0 1 -0.25 -0.25v-4.18a1 1 0 1 0 -2 0v4.47a2 2 0 0 0 2 2h0.25a0.25 0.25 0 0 1 0.25 0.25v2a0.25 0.25 0 0 1 -0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.91 14.56h-7.44a1 1 0 1 0 0 2H19a0.25 0.25 0 0 1 0.25 0.25V23a1 1 0 0 0 2 0v-6.2a0.25 0.25 0 0 1 0.25 -0.25h1.45a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEatingOut);
export default ForwardRef;